'use client'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { StoreDevtoolsName } from '@stores/store-names.const'

import { GATEWAY_LIST_FILTER_ALL } from '../constants/gatewayListFilters.const'

import { gatewayListMobileFiltersInitialState } from './gateway-list-mobile-filters.slice'
import type { GatewayListMobileFiltersStore } from './gateway-list-mobile-filters.type'

export const useGatewayListMobileFiltersStore = create<GatewayListMobileFiltersStore>()(
  devtools(
    (set) => ({
      ...gatewayListMobileFiltersInitialState,
      setOpenMenu: (openMenu) => set({ openMenu }),
      setPendingStatus: (status) => set((state) => ({ pending: { ...state.pending, status } })),
      setPendingRuntime: (runtime) => set((state) => ({ pending: { ...state.pending, runtime } })),
      setPendingFeed: (feed) => set((state) => ({ pending: { ...state.pending, feed } })),
      setPendingEnvironment: (environment) => set((state) => ({ pending: { ...state.pending, environment } })),
      hydratePending: (values) =>
        set((state) => ({
          pending: { ...state.pending, ...values },
          openMenu: null,
        })),
      applyCoercedPending: (updates) =>
        set((state) => ({
          pending: {
            ...state.pending,
            ...(updates.status !== undefined ? { status: updates.status } : {}),
            ...(updates.runtime !== undefined ? { runtime: updates.runtime } : {}),
            ...(updates.feed !== undefined ? { feed: updates.feed } : {}),
            ...(updates.projectKey !== undefined ? { environment: updates.projectKey } : {}),
          },
        })),
      resetPending: (environmentDefault) =>
        set({
          openMenu: null,
          pending: {
            status: GATEWAY_LIST_FILTER_ALL,
            runtime: GATEWAY_LIST_FILTER_ALL,
            feed: GATEWAY_LIST_FILTER_ALL,
            environment: environmentDefault,
          },
        }),
    }),
    {
      name: StoreDevtoolsName.GatewayListMobileFilters,
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
